import { render } from "./B2bFiltersOrdersEmit.vue?vue&type=template&id=189ec000&scoped=true&lang=pug"
import script from "./B2bFiltersOrdersEmit.vue?vue&type=script&lang=js"
export * from "./B2bFiltersOrdersEmit.vue?vue&type=script&lang=js"

import "./B2bFiltersOrdersEmit.vue?vue&type=style&index=0&id=189ec000&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189ec000"]])

export default __exports__